<template>
  <div class="detail">
    <div class="tablediv">
        <table class="detailtable" border>
      <tr>
        <td>请求开始时间</td>
        <td>{{parseTime(Message.RequestStartTime)}}</td>
        <td>请求结束时间</td>
        <td>{{parseTime(Message.ResponseEndTime)}}</td>
      </tr>
      <tr>
        <td>App名称</td>
        <td colspan="3">{{Message.AppName}}</td>
      </tr>
      <tr>
        <td>模式</td>
        <td>{{Message.ModelType}}</td>
        <td>App用户姓名</td>
        <td>{{Message.AppUserName}}</td>
      </tr>
      <tr>
        <td>请求内容</td>
        <td colspan="3">{{Message.RequestContent}}</td>
      </tr>
      <tr> 
        <td>响应最终结果</td>
        <td colspan="3">{{Message.ResponseResult}}</td>
      </tr>
      <tr>
        <td>请求内容</td>
        <td colspan="3" style="word-wrap:break-word;">{{Message.RequestBody}}</td>
      </tr>
      <tr> 
        <td>响应内容</td>
        <td colspan="3" style="word-wrap:break-word;">{{Message.ResponseBody}}</td>
      </tr>
      <tr> 
        <td>
          
        </td>
        <td colspan="3">
          <el-button type="primary" @click="back" class="back">返 回</el-button>
        </td>
      </tr>
    </table>
    </div>
  
  </div>
</template>

<script>
import {  ChatMessageDetail } from '@/api/chatMessage'
import { parseTime } from '@/utils/parseTime'
export default {
  data(){
    return{
      Message:{}
    }
},
  mounted(){
    this.handleDetailMessage({...this.$route.query})
},
  methods:{
    parseTime,
    async handleDetailMessage (row) {
      const [res, err] = await ChatMessageDetail(row.Id)
      this.Message = res.data.Data
    },
    back(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.detail{
  width: 100%;
  height: 100%;
  position: relative;
}
.tablediv{
  width: 100%;
  height: 80%;
   /* display: flex;
  align-content: center;
  justify-content: center; */
}
.detailtable{
 width: 100%;
 /* height: 30%; */
  max-width: 100%;
  max-height: 100%;
  /* min-height: 30%; */
  overflow: auto;
  border: 1px solid #000;
  border-collapse: collapse;
  table-layout: fixed;
}
.detailtable tr td:nth-child(1),.detailtable tr td:nth-child(3){
  background-color: rgb(236, 245, 255);
  white-space: nowrap;
}
.back{
  float: right;
}
</style>